import { render, staticRenderFns } from "./AuthenticationPage.vue?vue&type=template&id=8921a8f8&"
import script from "./AuthenticationPage.vue?vue&type=script&lang=js&"
export * from "./AuthenticationPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports